import { PRODUCTION_SLUG } from '../utils/environment';

const initialState = {
    // Every environment in the current workspace, default first.
    environments: [],
    // The one the dashboard is reading and writing. Null until a workspace loads.
    active: null,
    workspaceId: null,
    loading: false,
    error: null,
};

const environmentReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'ENVIRONMENTS_REQUEST':
            return { ...state, loading: true, error: null };
        // Provisional: the selection remembered for this workspace, before the
        // list has confirmed it still exists.
        case 'ENVIRONMENTS_RESTORED':
            return {
                ...state,
                workspaceId: action.payload.workspaceId,
                active: action.payload.active,
                // Another workspace's environments are not ours to offer. Kept
                // as-is for a reload of the same workspace, so reopening the
                // settings modals does not blank the list mid-refetch.
                environments:
                    state.workspaceId === action.payload.workspaceId
                        ? state.environments
                        : [],
            };
        case 'ENVIRONMENTS_SUCCESS':
            return {
                ...state,
                loading: false,
                environments: action.payload.environments,
                workspaceId: action.payload.workspaceId,
                active: action.payload.active,
            };
        case 'ENVIRONMENTS_FAIL':
            return { ...state, loading: false, error: action.payload };
        case 'ENVIRONMENT_SWITCHED':
            return { ...state, active: action.payload };
        case 'ENVIRONMENTS_CLEARED':
            return { ...initialState };
        default:
            return state;
    }
};

export const selectActiveEnvironmentSlug = (state) =>
    state.environments?.active?.slug ?? PRODUCTION_SLUG;

export default environmentReducer;
